import { useParams } from 'react-router-dom'
import AuthBasePageWrapper from '../../AuthBasePageWrapper'
import RecoveryPasswordPanel from './RecoveryPasswordPanel'
import NewPasswordPanel from './NewPasswordPanel'

const RecoveryPasswordPage = () => {
  const { token } = useParams()
  console.info('token', token)
  return (
    <AuthBasePageWrapper>
      {token ? <NewPasswordPanel token={token} /> : <RecoveryPasswordPanel />}
    </AuthBasePageWrapper>
  )
}

export default RecoveryPasswordPage
